// extracted by mini-css-extract-plugin
export default {"date_highlight_container":"DateHighlight_date_highlight_container__cQ5bj","month_big":"DateHighlight_month_big__Ng5Hu","date_big":"DateHighlight_date_big__e8gOb"};